<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>The Little Brown Jug</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head">CONTENTS</p>
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><span href="#/Dedication" title="Link target outside of Sample">Dedication</span></td></tr>
<tr><td colspan="2"><a href="#/Foreword#Fw">Foreword</a></td></tr>
<tr><td colspan="2"><a href="#/Acknowledgments#Ack">Acknowledgments</a></td></tr>
<tr><td colspan="2"><a href="#/Introduction#Intro">Introduction</a></td></tr>
<tr><td><span href="#/Chapter1#C1" title="Link target outside of Sample">1.</span></td><td><span href="#/Chapter1#C1" title="Link target outside of Sample">Pre-1903: Before the Battle for the Jug</span></td></tr>
<tr><td><span href="#/Chapter2#C2" title="Link target outside of Sample">2.</span></td><td><span href="#/Chapter2#C2" title="Link target outside of Sample">1903–1909: The Rivalry Begins</span></td></tr>
<tr><td><span href="#/Chapter3#C3" title="Link target outside of Sample">3.</span></td><td><span href="#/Chapter3#C3" title="Link target outside of Sample">1910–1933 Michigan Takes Charge</span></td></tr>
<tr><td><span href="#/Chapter4#C4" title="Link target outside of Sample">4.</span></td><td><span href="#/Chapter4#C4" title="Link target outside of Sample">1934–1942: Minnesota Dominates</span></td></tr>
<tr><td><span href="#/Chapter5#C5" title="Link target outside of Sample">5.</span></td><td><span href="#/Chapter5#C5" title="Link target outside of Sample">1943–1968: The Battle Continues</span></td></tr>
<tr><td><span href="#/Chapter6#C6" title="Link target outside of Sample">6.</span></td><td><span href="#/Chapter6#C6" title="Link target outside of Sample">1969–Present: Michigan Dominates</span></td></tr>
<tr><td colspan="2"><span href="#/Seriesrecord#Se" title="Link target outside of Sample">Series Record</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?470e5feb